module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return ((_vm.dataProp != null) && (_vm.optionsProp != null)) ? _c('draggable', {
    attrs: {
      "options": _vm.optionsProp.draggableComponent,
      "move": _vm.draggableDataOnMove
    },
    on: {
      "change": _vm.draggableDataOnChange,
      "start": _vm.draggableDataDraggingModeOnChange,
      "end": _vm.draggableDataDraggingModeOnChange
    },
    model: {
      value: (_vm.dataProp),
      callback: function($$v) {
        _vm.dataProp = $$v
      },
      expression: "dataProp"
    }
  }, [_c('transition-group', {
    staticClass: "dtv-properties-list-group",
    class: {
      'dtv-properties-list-group-show-empty': (_vm.dataProp.length == 0)
    },
    style: ((_vm.optionsProp.isRoot == true) ? 'margin-left:0px' : ''),
    attrs: {
      "name": "dtv-flip-list",
      "tag": "ul"
    }
  }, _vm._l((_vm.dataProp), function(element) {
    return _c('li', {
      key: element.val.id,
      staticClass: "dtv-properties-list-group-item",
      class: {
        'dtv-dragging-element': (_vm.commonDataBusProp.draggingElement != null) && (_vm.commonDataBusProp.draggingElement.val.id == element.val.id)
      }
    }, [_c('div', {
      staticClass: "dtv-property-box",
      class: _vm.getPropertyBoxClasses(element)
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "font-size": "17px"
      }
    }, [_c('Icon', {
      staticClass: "dtv-property-box-handle",
      attrs: {
        "type": "grid"
      }
    })], 1), _vm._v(" "), (element.children.length > 0) ? _c('div', {
      staticStyle: {
        "float": "left",
        "font-size": "17px",
        "padding": "0 5px 0 3px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.draggableDataToggleItem(element)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "arrow-right-b"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dtv-property-box-action-button",
      staticStyle: {
        "float": "right"
      }
    }, [_c('Button', {
      staticStyle: {
        "border-radius": "0px",
        "margin": "-5px 0 0 10px",
        "padding": "0px",
        "color": "rgb(149,158,165)",
        "font-size": "17px"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          _vm.dataRowOnDelete(element)
        }
      }
    }, [_c('Icon', {
      attrs: {
        "type": "trash-b"
      }
    })], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-top": "3px",
        "height": "17px",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.dataRowOnSelect(element)
        }
      }
    }, [_vm._t("propertyBox", [_vm._v(" Нет данных ")], {
      dataRow: element
    })], 2)]), _vm._v(" "), (((element.children.length > 0) && (element.ui.toggle == true)) || _vm.doesEmptyChildrenListShow(element)) ? _c('div', [_c('dragg-treeview', {
      staticStyle: {
        "padding-top": "1px"
      },
      attrs: {
        "data": element.children,
        "commondatabus2": _vm.commonDataBusProp,
        "options": _vm.optionsPropForChildren
      },
      on: {
        "update:data": function($event) {
          element.children = $event
        },
        "update:commondatabus2": function($event) {
          _vm.commonDataBusProp = $event
        },
        "change": _vm.emitChangeToUpper,
        "select": _vm.emitSelectToUpper,
        "delete": _vm.emitDeleteToUpper
      },
      scopedSlots: _vm._u([{
        key: "propertyBox",
        fn: function(viewProps) {
          return [_vm._t("propertyBox", [_vm._v(" Нет данных ")], {
            dataRow: viewProps.dataRow
          })]
        }
      }])
    })], 1) : _vm._e()])
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-271a15d8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/technical/components/Treeview/DraggTreeview.vue
// module id = 369
// module chunks = 0